module.exports = __webpack_public_path__ + "img/Search.5f690b61.svg";